// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgAutorefreshPause24 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<g clipPath="url(#autorefresh_pause_24_svg__a)">
			<path
				fill="#A0B6C3"
				d="M12 24c6.563 0 12-5.425 12-12 0-6.563-5.437-12-12.012-12C5.425 0 0 5.437 0 12c0 6.575 5.437 12 12 12Zm0-2.358A9.608 9.608 0 0 1 2.37 12a9.588 9.588 0 0 1 9.618-9.63c5.344 0 9.654 4.286 9.654 9.63A9.618 9.618 0 0 1 12 21.642Zm-3.322-5.077h1.208c.592 0 .883-.325.883-.813V8.236c0-.488-.29-.813-.883-.813H8.678c-.581 0-.872.325-.872.813v7.516c0 .488.29.813.872.813Zm5.436 0h1.208c.581 0 .872-.325.872-.813V8.236c0-.488-.29-.813-.872-.813h-1.208c-.592 0-.894.325-.894.813v7.516c0 .488.302.813.894.813Z"
			/>
		</g>
		<defs>
			<clipPath id="autorefresh_pause_24_svg__a">
				<path fill="#fff" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);
export default SvgAutorefreshPause24;
